import styled from '@emotion/styled'

import TemplateHeader from '@/components/templates/TemplateHeader'
import TemplateHero from '@/components/templates/TemplateHero'
import { TemplateButton } from '@/components/templates/TemplateButton'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'

const Layout = styled.section``

Layout.Header = styled(TemplateHeader)`
  display: flex;  
  height: 80px;
  width: 100%;
  position: absolute !important;
  top: 0;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 16px;
  color: #ffffff;
  font-weight: 700;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  gap: 3em;
`

Layout.Link = styled.span`
  margin-left: 10px;
  font-weight: 700;
`

Layout.Hero = styled(TemplateHero)``

Layout.HeroContainer = styled.div`
  display: flex;
  min-height: var(--preview-height);
  max-height: var(--preview-height);
  width: 100%;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
  align-items: center;
`

Layout.TitleContainer = styled.div`
  display: flex;
  flex-basis: 50%;
  max-width: 570px;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 6em;
  color: #ffffff;
  margin: auto 0;
  margin-left: auto;
`

Layout.Title = styled.h1`
  font-size: 76px;
  color: ${({theme}) => theme.palette.primary.main};
  font-weight: 700;
  line-height: 1em;
`
Layout.Subtitle = styled.p`
  font-size: 24px;
  color: ${({theme}) => theme.palette.text.secondary};
  font-weight: 500;
`
Layout.CTA = styled(TemplateButton)`
  width: fit-content;
  font-size: 16px;
  font-weight: 700;
  padding: 12px 30px;
  margin-top: 4em;
  width: 100%;
  svg {
    display: inline-block;
    margin-left: 1em;
  }
`
Layout.HeroImageContainer = styled.div`
  overflow: hidden;
  width: 50%;
`

Layout.Button = styled(TemplateButton)`
  padding: 12px 30px;
  border: none;
  margin: 20px 0;
  font-weight: 600;
  svg {
    display: inline-block;
    margin-right: 1em;
  }
`

export default Layout
